// 网络请求相关
import axios from 'axios'

import { MessageBox, Message, Alert } from 'element-ui'
import store from '../store/index'
import { setToken } from '@/utils/auth'

const errorPrompt = (err) => {
  Message({
    message: err,
    type: 'error',
    center: true,
    duration: 2500
  })
}

const baseUrl = process.env.VUE_APP_BASE_API

const request = axios.create({
  timeout: 20000, // request timeout,
  baseURL: baseUrl
})

request.interceptors.request.use((request) => {
  console.log('baseUrl==', request.baseURL)
  request.headers.common = {
    'Content-Type': 'application/json; charset=utf-8',
    'Authorization': 'Bearer ' + store.getters.token
  }
  return request
}
)
// response interceptor
request.interceptors.response.use(
  response => {
    const headers = response.headers
    // 如果有该请求头 即 token 刷新
    const token = headers.authorization
    if (token) {
      store.commit('SET_TOKEN', token)
      setToken(token)
    }

    const res = response.data
    // if(res.code===2000){
    if (res.code === 100000) {
      res.messageType = 'success'
      return res
    } else {
      if (res.code === 400) {
        Message({
          message: '当前用户发身份信息失效，请重新登录！2秒后为您跳转...',
          type: 'warning',
          duration: 2000
        })
        setTimeout(() => {
          store.dispatch('user/logout').then(() => {
            location.reload()// In order to re-instantiate the vue-router object to avoid bugs
          })
        }, 2000)
        return Promise.reject()
      } else {
        // Message({
        //   message: res.message || '请求失败',
        //   type: 'error',
        //   duration: 3000
        // })
        return res
      }
    }
  },

  error => {
    // errorPrompt('请求失败,请稍候再试')
    return Promise.reject()
  }
)

export default request
